import { render, staticRenderFns } from "./ValidatorIcon.vue?vue&type=template&id=628d296c&scoped=true&"
import script from "./ValidatorIcon.vue?vue&type=script&lang=ts&"
export * from "./ValidatorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorIcon.vue?vue&type=style&index=0&id=628d296c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d296c",
  null
  
)

export default component.exports